import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {SimpleItem} from 'devextreme-react/form';


export default class FormSimpleItem extends Component {
    render() {
        return <SimpleItem
            {...omit(['loading_state', 'setProps', 'children'], this.props)}
        />
    }
}

FormSimpleItem.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    buttonOptions: PropTypes.object,
    /**
     * Specifies the number of columns spanned by the item
     */
    colSpan: PropTypes.number,
    /**
     * An alias for the template property specified in React. Accepts a custom component.
     */
    component: PropTypes.object,
    /**
     * Specifies a CSS class to be applied to the form item
     */
    cssClass: PropTypes.string,
    /**
     * Specifies the path to the formData object field bound to the current form item
     */
    dataField: PropTypes.string,
    /**
     * Configures the form item's editor
     */
    editorOptions: PropTypes.object,
    /**
     * Specifies which editor UI component is used to display and edit the form item value
     */
    editorType: PropTypes.oneOf(['dxAutocomplete', 'dxCalendar', 'dxCheckBox', 'dxColorBox', 'dxDateBox',
        'dxDropDownBox', 'dxHtmlEditor', 'dxLookup', 'dxNumberBox', 'dxRadioGroup', 'dxRangeSlider',
        'dxSelectBox', 'dxSlider', 'dxSwitch', 'dxTagBox', 'dxTextArea', 'dxTextBox']),
    /**
     * Specifies the help text displayed for the current form item
     */
    helpText: PropTypes.string,
    /**
     * Specifies whether the current form item is required
     */
    isRequired: PropTypes.bool,
    /**
     * Specifies the item's type. Set it to "simple" to create a simple item
     */
    itemType: PropTypes.oneOf(['empty', 'group', 'simple', 'tabbed', 'button']),
    /**
     * Specifies properties for the form item label
     */
    label: PropTypes.object,
    /**
     * Specifies a name that identifies the form item
     */
    name: PropTypes.string,
    /**
     * An alias for the template property specified in React. Accepts a rendering function.
     */
    render: PropTypes.func,
    /**
     * A template that can be used to replace the default editor with custom content
     */
    template: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * An array of validation rules to be checked for the form item editor
     */
    validationRules: PropTypes.arrayOf(PropTypes.object),
    /**
     * Specifies whether or not the current form item is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the sequence number of the item in a form, group or tab
     */
    visibleIndex: PropTypes.number,

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

FormSimpleItem.defaultProps = {
    // colSpan: undefined,
    // component:
    // cssClass: undefined,
    // dataField: undefined,
    // editorOptions: undefined,
    // editorType: 'dxTextBox',
    // helpText: undefined,
    // isRequired: undefined,
    itemType: 'simple',
    // label: undefined,
    // name: undefined,
    // render: undefined,
    // template: undefined,
    // validationRules: undefined,
    visible: true,
    // visibleIndex: undefined
};
